import React from 'react';

import { MiniGridRow, ChildrenProps } from '../Row/Row';
import { TestProps } from '../../../internal/types/testTypes';
import { cn } from '../../../lib/css/className/className';
import { HeaderRowContext } from '../context';

const cls = cn('MiniGridHeaderRow');
const defaultValue = {
    isHeaderRow: true,
};

export interface MiniGridHeaderRowProps extends TestProps, ChildrenProps {
    /**
     * Названия классов для элемента
     */
    className?: string;
}

export const MiniGridHeaderRow = function MiniGridHeaderRow(props: MiniGridHeaderRowProps) {
    const { children, className, 'data-testid': dataTestId = 'MiniGridHeaderRow' } = props;

    return (
        <HeaderRowContext.Provider value={defaultValue}>
            <MiniGridRow id="miniGridHeaderRow" data-testid={dataTestId} className={cls('', [className])}>
                {children}
            </MiniGridRow>
        </HeaderRowContext.Provider>
    );
};
